import { MoodSchema, type Mood } from 'shared';

/**
 * Foundation helper: readDomMood（R2 Wave2B・2026-06-21）
 *
 * 「いま画面に出ている mood」を <html data-mood="..."> から読む小ヘルパ。
 * semantic コンポーネント（JudgementModal / FailOverlay / HintBubble / StartGate /
 * AdvanceTrigger）は mood 引数を持たない設計のため、効果音を鳴らす**発火の瞬間**に
 * この関数で mood を解決し、useMinigameSound / audioEngine へ渡す。
 *
 * これで「画面の色（data-mood）」と「音色」が常に自動一致する:
 *   - App.tsx が scenario.theme.mood.primary（or tension 上乗せ）を data-mood へ反映
 *   - MinigameSandbox が ?mood= を data-mood へ反映
 *   いずれの経路でも、ここを読めば現在 mood が取れる。
 *
 * 型安全:
 *   - data-mood が無い / MoodSchema の 7 種以外 / DOM 不在（SSR・テスト）の場合は
 *     undefined を返す。audioEngine 側は mood 未指定を「中庸トーン」で安全に扱う。
 *   - throw しない（音は付加機能であり、解決失敗で描画を巻き込まない）。
 */
export function readDomMood(): Mood | undefined {
  if (typeof document === 'undefined') return undefined;
  const root = document.documentElement;
  if (!root) return undefined;
  const raw = root.getAttribute('data-mood');
  if (!raw) return undefined;
  // MoodSchema の 7 種以外（タイポ・将来値）は undefined に落とす（型安全）。
  const parsed = MoodSchema.safeParse(raw);
  return parsed.success ? parsed.data : undefined;
}
